var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "plan-tooltip",
        { attrs: { page: _vm.currentPagePlan, disabled: !_vm.disableToggle } },
        [
          _vm.loading
            ? _c("inline-loader", {
                staticClass: "mx-2",
                attrs: { width: "16px", height: "16px" },
              })
            : _c(
                "b",
                {
                  staticClass: "bold clickable small text-capitalize",
                  class: _vm.activeClass,
                  on: { click: _vm.handleToggleActive },
                },
                [_vm._v("\n      " + _vm._s(_vm.activeText) + "\n    ")]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }